import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { usePromoteYourPetition } from './hooks/usePromoteYourPetition';

export const PromoteYourPetition: React.FC = () => {
	const { data, actions } = usePromoteYourPetition();
	const { translate } = useI18n();

	return (
		<section data-qa="promote-petition-container" className="bg-background-base flex flex-col gap-6 px-4 py-8 md:p-12">
			<div className="flex flex-col sm:gap-3 md:gap-6">
				<Text
					className="text-size-heading-small text-typography-strong"
					id="promote-petition-title"
					data-qa="promote-petition-title"
					as="h3"
					fontWeight="bold"
				>
					<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.title" />
				</Text>
				<Text id="promote-petition-description" className="text-typography-strong" as="p">
					<Translate
						value={`corgi.petition.starter_dashboard.grow_petition.promote.paragraph_1${
							data.shouldUseDonationLanguage ? '_donation' : ''
						}`}
					/>
					<br />
					<br />
					<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.paragraph_2" />
				</Text>
			</div>

			<div className="flex flex-row gap-6">
				<Button
					data-qa="promote-petition-button"
					data-testid="promote"
					variant="secondary"
					size="small"
					className="text-typography-strong"
					as="a"
					href={data.promotionUrl}
					onClick={actions.trackPromotePetitionClick}
					aria-label={translate('corgi.petition.starter_dashboard.grow_petition.promote.promote_button')}
				>
					<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.promote_button" />
				</Button>
				<Button
					data-qa="promote-petition-learn-more-link"
					data-testid="learn_more"
					variant="tertiary"
					size="small"
					className="text-typography-strong"
					as="a"
					href={data.promotionHelpUrl}
					onClick={actions.trackLearnMoreClick}
					aria-label={translate('corgi.petition.starter_dashboard.grow_petition.promote.learn_link')}
				>
					<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.learn_link" />
				</Button>
			</div>
		</section>
	);
};
